/* ============================================================
 * RUSTIC WREN — Product page (Template A) behaviour
 * Atelier draft theme only.
 *
 * The embossing input lives in a custom-liquid buy-box block and is
 * associated with Atelier's add-to-cart form via its form="..." attribute,
 * so it submits natively (no JS needed for the cart). The input also
 * carries name="properties[Embossing]" in the markup, so initials are
 * captured even if this script fails to load.
 *
 * This script only:
 *   1. Removes the name attribute while the field is empty -- so an empty
 *      field never adds a blank "Embossing:" line to the order -- and
 *      restores it as soon as the customer types.
 *   2. Mirrors the typed letters onto the leather preview tile, exactly
 *      as typed. Embossing is stamped as written (upper or lowercase),
 *      so the preview must not change the case.
 * ============================================================ */
(function () {
  var PROP = 'properties[Embossing]';

  function sync(input) {
    var value = (input.value || '').trim();
    if (value) input.setAttribute('name', PROP);
    else input.removeAttribute('name');

    var tile = document.querySelector('.rw-emboss-swatch-text');
    if (tile) tile.textContent = value || 'JMB';
  }

  function init() {
    var input = document.querySelector('.rw-emboss-input');
    if (!input) return;
    sync(input); // start clean: no name until the customer types
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('rw-emboss-input')) {
      sync(e.target);
    }
  });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
